import { ChangeDetectionStrategy, Component } from '@angular/core';
import { createProvider, Step } from '../../../../../../shared/IFE/step/step/step';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { AnalyticsService } from '../../../../../../shared/modules/analytics/services/analytics.service';
import { BooleanQuestionValues } from '../../../../models/constants';

@Component({
  selector: 'evc-quote-personal-details-existing-client',
  providers: [createProvider(ExistingClientQuoteComponent)],
  templateUrl: './existing-client-quote.component.html',
  styleUrls: ['./existing-client-quote.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExistingClientQuoteComponent extends Step {
  readonly formName = 'evcQuote';
  readonly stepName = 'personal-details-existing-client';
  readonly booleanQuestionValues = BooleanQuestionValues;

  constructor(fb: UntypedFormBuilder, analyticsService: AnalyticsService) {
    super(fb, analyticsService);
  }

  writeValue(values): void {
    super.writeValue(values);
    this.updateValidity(values);
  }

  protected valueChanges(values) {
    // Make sure all our checkboxes get the event.
    this.control.get('existingClient').patchValue(values.existingClient, { emitEvent: false });
    // Update validation.
    this.updateValidity(values);
    super.valueChanges(values);

    if (values.existingClient === BooleanQuestionValues.no) {
      super.navigate();
    }
  }

  protected buildForm() {
    this.control = this.fb.group({
      existingClient: ['', [Validators.required]],
      clientNumber: this.fb.control(''),
    });

    this.subscribeToValueChanges(false);
  }

  private updateValidity(values) {
    if (!values) {
      return;
    }

    if (values?.existingClient === BooleanQuestionValues.yes) {
      this.control.get('clientNumber').setValidators([Validators.pattern('E[0-9]{8,9}')]);
    } else {
      this.control.get('clientNumber').patchValue('', { emitEvent: false });
      this.control.get('clientNumber').clearValidators();
    }
    this.control.get('clientNumber').updateValueAndValidity({ emitEvent: false });
  }
}
